import { ExonerationReason } from "./exoneration-reason";

export class TaxExemption {
    reason: ExonerationReason;
    documentId: string;
    documentId2: string;
    date: string;

    constructor() {
        this.reason = new ExonerationReason();
        this.documentId = "";
        this.date = "";
        this.documentId2 = "";
    }

    static build(reason: ExonerationReason, documentId: string, documentId2: string, date: string): TaxExemption {
        let result = new TaxExemption();
        result.reason = reason;
        result.documentId = documentId;
        result.documentId2 = documentId2;
        result.date = date;
        return result;
    }
}